import dayjs from 'dayjs';

function isDisabled(_ref) {
  var minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      excludeDate = _ref.excludeDate,
      disableOutsideEvents = _ref.disableOutsideEvents,
      date = _ref.date,
      outside = _ref.outside;
  var isAfterMax = maxDate instanceof Date && dayjs(maxDate).isBefore(date, "day");
  var isBeforeMin = minDate instanceof Date && dayjs(minDate).isAfter(date, "day");
  var shouldExclude = typeof excludeDate === "function" && excludeDate(date);
  var disabledOutside = !!disableOutsideEvents && !!outside;
  return isAfterMax || isBeforeMin || shouldExclude || disabledOutside;
}

export { isDisabled };